import './Projects.css';

const projectData = [
  {
    title: 'Locker Management Back-office',
    description: 'First 100% cloud-native project at MM Spain. A back-office for international locker management, setting the standard for future cloud migrations.',
    stack: ['Next.js', 'React', 'GCP', 'OAuth', 'GraphQL']
  },
  {
    title: 'Employee Time-Tracking App',
    description: 'Developed from scratch for +400 employees (Final Degree Project). Replaced a legacy system with a modern, fast, and user-friendly interface.',
    stack: ['.NET 8', 'React', 'SQL Server', 'UI/UX Design']
  },
  {
    title: 'Personal Mobile App (In Dev)',
    description: 'A personal project to explore mobile development and modern BaaS. Features secure auth using Row Level Security.',
    stack: ['React Native', 'Supabase', 'RLS']
  },
  {
    title: 'OCR Accounting Automation',
    description: 'Developed at Matrix. An OCR solution to scan, extract, and automate accounting data from invoices and fiscal documents.',
    stack: ['.NET Core', 'WPF', 'SQL Server', 'OCR']
  },
  {
   title: 'This Portfolio Website',
   description: 'The responsive single-page application you are currently viewing. Built from scratch with React, TypeScript, and modern CSS, featuring scroll-based animations and an interactive code modal.',
   stack: ['React', 'TypeScript', 'CSS'],
  }
];

const Projects = () => {
  return (
    <div className="projects-container full-page-section section-padding" id="projects">
      <h2>// My Projects</h2>
      <div className="projects-grid">
        {projectData.map((project, index) => (
          <div className="project-card" key={index}>
            <h3>{project.title}</h3>
            <p>{project.description}</p>
            <div className="project-stack">
              {project.stack.map((tech, i) => (
                <span key={i} className="tech-tag">{tech}</span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Projects;